<p-messages [value]="message"></p-messages>
<p-card>
    <button pButton type="button" label="Add Group" (click)="emitAddEvent(true)"></button>
    <p-table #dtuserGroups [value]="userGroups" 
        autoLayout=true 
        [paginator]="true" 
        [loading]="loading" 
        [rows]="10" 
        [rowsPerPageOptions]="[10,25,50,100]" 
        [globalFilterFields]="['PrivilegeGroup.GroupName','RelationshipName']"
        dataKey="PrivilegeGroup.CompanyGroupId">
        <ng-template pTemplate="caption">
            <div class="search-container">        
                <i class="pi pi-search filterInput"></i>
                <input type="text" pInputText size="50" placeholder="Filter By: Group Name, Partnership" (input)="dtuserGroups.filterGlobal($event.target.value, 'contains')" style="width:auto">
            </div>
        </ng-template>
        <ng-template pTemplate="header">                                                                                                                                    
            <tr>
                <th style="width: 3em"></th>
                <th>Group Name</th>
                <th>Partnership</th>
                <th>User Count</th>
                <th>Actions</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-group>
            <tr>
                <td></td>
                <td>{{group.PrivilegeGroup.GroupName}}</td>
                <td>{{group.RelationshipName}}</td>
                <td>
                    <a target="_blank" (click)="displayUsersDialog(group.PartnerUsers)" *ngIf="group.PartnerUsers.length>0">{{group.PartnerUsers.length}}</a>
                    <span *ngIf="group.PartnerUsers.length===0">0</span>
                </td>
                <td>
                    <i class="pi pi-fw pi-pencil action" (click)="emitEditEvent(true, group)" *ngIf="group.PrivilegeGroup.IsMasterGroup !== 1"></i>    
                    <i class="pi pi-fw pi-trash action" (click)="deleteUserGroup(group.PrivilegeGroup)" *ngIf="(group.PartnerUsers.length===0) && group.PrivilegeGroup.IsMasterGroup !== 1"></i>            
                </td>
            </tr>
        </ng-template>
    </p-table>
    
    <p-dialog [(visible)]="showUsersDialog" 
        [modal]="true"
        [positionTop]="50"
        [maximizable]="true"
        [contentStyle]="{'min-width':'700px'}">
        <p-header><b>Users</b></p-header>
        <p-table [value]="usersInGroup" autoLayout=true [paginator]="true" [loading]="loading" [rows]="10" [rowsPerPageOptions]="[10,25,50,100]">
            <ng-template pTemplate="body" let-users>
                <tr>
                    <td *ngIf="(users.Person.FirstName && users.Person.FirstName.trim() !== '') || (users.Person.LastName && users.Person.LastName.trim() !== '')">{{users.Person.FirstName}} {{users.Person.LastName}}</td>
                    <td *ngIf="(!users.Person.FirstName || users.Person.FirstName.trim() === '') && (!users.Person.LastName || users.Person.LastName.trim() === '') && (users.Person.Email && users.Person.Email.trim() !== '')">{{users.Person.Email}}</td>
                    <td *ngIf="(!users.Person.FirstName || users.Person.FirstName.trim() === '') && (!users.Person.LastName || users.Person.LastName.trim() === '') && (!users.Person.Email || users.Person.Email.trim() === '')">Unregistered user. No email present.</td>
                </tr>
            </ng-template>
        </p-table>
    </p-dialog>

    <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
</p-card>